import { FormInstance } from "antd/es/form";
import { Guid } from "guid-typescript";
import React from "react";
import { IValidationData } from "../../models/dto/validation-data";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";

declare let window: any;

interface IRequestImagesMobil_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface IRequestImagesMobil_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  RequestImageGet: any[];
  RequestImageGet_dummy: any[];
  PhotosFromGallery: any[];
  PhotosFromGallery_dummy: any[];
  SetValueOf: string;
  SetValueOf_dummy: string;
  SaveRecord_1: number;
  SaveRecord_1_dummy: number;
  DownloadFile: string;
  DownloadFile_dummy: string;
  NAVIGATE: string;
  NAVIGATE_dummy: string;
  SaveRecord_2: number;
  SaveRecord_2_dummy: number;
  SaveRecord_3: number;
  SaveRecord_3_dummy: number;
  SaveRecord_4: number;
  SaveRecord_4_dummy: number;
  RequestImageSave: number;
  RequestImageSave_dummy: number;
  TriggerEvent: string;
  TriggerEvent_dummy: string;
  GoBack: string;
  GoBack_dummy: string;
  isComp435247Visible: "visible" | "hidden";
  isComp582336Visible: "visible" | "hidden";
  isComp969827Visible: "visible" | "hidden";
  isComp656449Visible: "visible" | "hidden";
  isComp589927Visible: "visible" | "hidden";
  isComp733066Visible: "visible" | "hidden";
  isComp633549Visible: "visible" | "hidden";
  wfScreenName: string;
}

export class RequestImagesMobil_ScreenBase extends React.PureComponent<IRequestImagesMobil_ScreenProps, any> {
  ml = [
    {
      Id: "4f05fda5-b043-9e86-8437-71ea4357a314",
      Name: "tr_TR",
      ShortName: "Turkish",
      IsDefault: true,
      LanguagePhrases: []
    },
    { Id: "7a8fc238-9831-4128-a954-0cdac59f257a", Name: "en_US", ShortName: "English", LanguagePhrases: [] },
    {
      Id: "11660921-ba95-4c30-84f9-98702fc82c3a",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        { Id: 49661, PropertyName: "value", Value: "Resim 1 (Önden Çekim)" },
        { Id: 873079, PropertyName: "value", Value: "Resim 2 (Yandan Çekim)" },
        { Id: 71823, PropertyName: "value", Value: "Resim 3 (Yakından Çekim)" },
        { Id: 755768, PropertyName: "label", Value: "Kaydet/Kapat" }
      ]
    }
  ];
  defaultML = "tr_TR";

  screenHash = "";

  constructor(props) {
    super(props);

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      RequestImageGet: [],
      PhotosFromGallery: [],
      SetValueOf: "",
      SaveRecord_1: false,
      DownloadFile: "",
      NAVIGATE: "",
      SaveRecord_2: false,
      SaveRecord_3: false,
      SaveRecord_4: false,
      RequestImageSave: 0,
      TriggerEvent: "",
      GoBack: "",
      isComp435247Visible: "hidden",
      isComp582336Visible: "hidden",
      isComp969827Visible: "hidden",
      isComp656449Visible: "hidden",
      isComp589927Visible: "hidden",
      isComp733066Visible: "hidden",
      isComp633549Visible: "hidden",
      wfScreenName: ""
    };

    this.state.isPageVisible = true;
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight("requestimagesmobil", "");
      return;
    }

    ReactSystemFunctions.validateToken();
    if (true) {
      await this.RequestImagesMobilPageInit();
    }

    KuikaAppManager.calculateAndSetBodyHeight("requestimagesmobil", "");
  }

  componentWillUnmount() {}

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight("requestimagesmobil", "");
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.RequestImagesMobilPageInit();
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({
      requestimagesmobil_155149_value: this.state.RequestImageGet?.at?.(0)?.frontView ?? undefined,
      requestimagesmobil_215414_value: this.state.RequestImageGet?.at?.(0)?.sideView ?? undefined,
      requestimagesmobil_554399_value: this.state.RequestImageGet?.at?.(0)?.closeUpView ?? undefined
    });
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: []
        }
      ]);
    }
  };

  RequestImagesMobilPageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find((v) => !v.isValid && v.condition);
      if (invalidValidation) {
        const fieldIdMatch = invalidValidation.formName.match(/\d+/);
        if (fieldIdMatch) {
          const fieldId = fieldIdMatch[0];
          const fieldElement = document.getElementById(fieldId);
          if (fieldElement) {
            fieldElement.scrollIntoView({ behavior: "smooth", block: "center" });
          }
        }
      }
      return true;
    }

    let localVar = {
      RequestFormID_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.ReguestFormID ?? this.props.screenInputs.reguestformid,
        "Guid"
      )
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(this, "RequestImagesMobil/RequestImagesMobilPageInit", localVar);
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.RequestImageGet = result?.data.requestImageGet;
    formVars.requestimagesmobil_155149_value = ReactSystemFunctions.toString(
      this,
      stateVars.RequestImageGet !== undefined
        ? stateVars.RequestImageGet?.length > 0
          ? stateVars.RequestImageGet[0].frontView
          : null
        : this.state.RequestImageGet?.length > 0
        ? this.state.RequestImageGet[0].frontView
        : null
    );
    formVars.requestimagesmobil_215414_value = ReactSystemFunctions.toString(
      this,
      stateVars.RequestImageGet !== undefined
        ? stateVars.RequestImageGet?.length > 0
          ? stateVars.RequestImageGet[0].sideView
          : null
        : this.state.RequestImageGet?.length > 0
        ? this.state.RequestImageGet[0].sideView
        : null
    );
    formVars.requestimagesmobil_554399_value = ReactSystemFunctions.toString(
      this,
      stateVars.RequestImageGet !== undefined
        ? stateVars.RequestImageGet?.length > 0
          ? stateVars.RequestImageGet[0].closeUpView
          : null
        : this.state.RequestImageGet?.length > 0
        ? this.state.RequestImageGet[0].closeUpView
        : null
    );
    stateVars.isComp582336Visible =
      ReactSystemFunctions.isNotEmpty(
        stateVars.RequestImageGet !== undefined
          ? stateVars.RequestImageGet?.length > 0
            ? stateVars.RequestImageGet[0].frontView
            : null
          : this.state.RequestImageGet?.length > 0
          ? this.state.RequestImageGet[0].frontView
          : null,
        null
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp969827Visible =
      ReactSystemFunctions.isNotEmpty(
        stateVars.RequestImageGet !== undefined
          ? stateVars.RequestImageGet?.length > 0
            ? stateVars.RequestImageGet[0].frontView
            : null
          : this.state.RequestImageGet?.length > 0
          ? this.state.RequestImageGet[0].frontView
          : null,
        null
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp656449Visible =
      ReactSystemFunctions.isNotEmpty(
        stateVars.RequestImageGet !== undefined
          ? stateVars.RequestImageGet?.length > 0
            ? stateVars.RequestImageGet[0].sideView
            : null
          : this.state.RequestImageGet?.length > 0
          ? this.state.RequestImageGet[0].sideView
          : null,
        null
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp589927Visible =
      ReactSystemFunctions.isNotEmpty(
        stateVars.RequestImageGet !== undefined
          ? stateVars.RequestImageGet?.length > 0
            ? stateVars.RequestImageGet[0].sideView
            : null
          : this.state.RequestImageGet?.length > 0
          ? this.state.RequestImageGet[0].sideView
          : null,
        null
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp733066Visible =
      ReactSystemFunctions.isNotEmpty(
        stateVars.RequestImageGet !== undefined
          ? stateVars.RequestImageGet?.length > 0
            ? stateVars.RequestImageGet[0].closeUpView
            : null
          : this.state.RequestImageGet?.length > 0
          ? this.state.RequestImageGet[0].closeUpView
          : null,
        null
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp633549Visible =
      ReactSystemFunctions.isNotEmpty(
        stateVars.RequestImageGet !== undefined
          ? stateVars.RequestImageGet?.length > 0
            ? stateVars.RequestImageGet[0].closeUpView
            : null
          : this.state.RequestImageGet?.length > 0
          ? this.state.RequestImageGet[0].closeUpView
          : null,
        null
      ) === true
        ? "visible"
        : "hidden";
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.RequestImagesMobilPageInit1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  RequestImagesMobilPageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find((v) => !v.isValid && v.condition);
      if (invalidValidation) {
        const fieldIdMatch = invalidValidation.formName.match(/\d+/);
        if (fieldIdMatch) {
          const fieldId = fieldIdMatch[0];
          const fieldElement = document.getElementById(fieldId);
          if (fieldElement) {
            fieldElement.scrollIntoView({ behavior: "smooth", block: "center" });
          }
        }
      }
      return true;
    }

    formVars.requestimagesmobil_155149_value = ReactSystemFunctions.toString(
      this,
      stateVars.RequestImageGet !== undefined
        ? stateVars.RequestImageGet?.length > 0
          ? stateVars.RequestImageGet[0].frontView
          : null
        : this.state.RequestImageGet?.length > 0
        ? this.state.RequestImageGet[0].frontView
        : null
    );

    stateVars.isComp582336Visible =
      ReactSystemFunctions.isNotEmpty(
        stateVars.RequestImageGet !== undefined
          ? stateVars.RequestImageGet?.length > 0
            ? stateVars.RequestImageGet[0].frontView
            : null
          : this.state.RequestImageGet?.length > 0
          ? this.state.RequestImageGet[0].frontView
          : null,
        null
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp969827Visible =
      ReactSystemFunctions.isNotEmpty(
        stateVars.RequestImageGet !== undefined
          ? stateVars.RequestImageGet?.length > 0
            ? stateVars.RequestImageGet[0].frontView
            : null
          : this.state.RequestImageGet?.length > 0
          ? this.state.RequestImageGet[0].frontView
          : null,
        null
      ) === true
        ? "visible"
        : "hidden";
    formVars.requestimagesmobil_215414_value = ReactSystemFunctions.toString(
      this,
      stateVars.RequestImageGet !== undefined
        ? stateVars.RequestImageGet?.length > 0
          ? stateVars.RequestImageGet[0].sideView
          : null
        : this.state.RequestImageGet?.length > 0
        ? this.state.RequestImageGet[0].sideView
        : null
    );

    stateVars.isComp656449Visible =
      ReactSystemFunctions.isNotEmpty(
        stateVars.RequestImageGet !== undefined
          ? stateVars.RequestImageGet?.length > 0
            ? stateVars.RequestImageGet[0].sideView
            : null
          : this.state.RequestImageGet?.length > 0
          ? this.state.RequestImageGet[0].sideView
          : null,
        null
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp589927Visible =
      ReactSystemFunctions.isNotEmpty(
        stateVars.RequestImageGet !== undefined
          ? stateVars.RequestImageGet?.length > 0
            ? stateVars.RequestImageGet[0].sideView
            : null
          : this.state.RequestImageGet?.length > 0
          ? this.state.RequestImageGet[0].sideView
          : null,
        null
      ) === true
        ? "visible"
        : "hidden";
    formVars.requestimagesmobil_554399_value = ReactSystemFunctions.toString(
      this,
      stateVars.RequestImageGet !== undefined
        ? stateVars.RequestImageGet?.length > 0
          ? stateVars.RequestImageGet[0].closeUpView
          : null
        : this.state.RequestImageGet?.length > 0
        ? this.state.RequestImageGet[0].closeUpView
        : null
    );

    stateVars.isComp733066Visible =
      ReactSystemFunctions.isNotEmpty(
        stateVars.RequestImageGet !== undefined
          ? stateVars.RequestImageGet?.length > 0
            ? stateVars.RequestImageGet[0].closeUpView
            : null
          : this.state.RequestImageGet?.length > 0
          ? this.state.RequestImageGet[0].closeUpView
          : null,
        null
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp633549Visible =
      ReactSystemFunctions.isNotEmpty(
        stateVars.RequestImageGet !== undefined
          ? stateVars.RequestImageGet?.length > 0
            ? stateVars.RequestImageGet[0].closeUpView
            : null
          : this.state.RequestImageGet?.length > 0
          ? this.state.RequestImageGet[0].closeUpView
          : null,
        null
      ) === true
        ? "visible"
        : "hidden";

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  RequestImagesMobilComponent_364326_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find((v) => !v.isValid && v.condition);
      if (invalidValidation) {
        const fieldIdMatch = invalidValidation.formName.match(/\d+/);
        if (fieldIdMatch) {
          const fieldId = fieldIdMatch[0];
          const fieldElement = document.getElementById(fieldId);
          if (fieldElement) {
            fieldElement.scrollIntoView({ behavior: "smooth", block: "center" });
          }
        }
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.PhotosFromGallery = (
      (await ReactSystemFunctions.getPhotosFromGallery(
        true,
        ReactSystemFunctions.convertToTypeByName("high", "string")
      )) as any
    ).data;
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName("requestimagesmobil_155149_value", "string"),
      ReactSystemFunctions.value(
        this,
        stateVars.PhotosFromGallery !== undefined
          ? stateVars.PhotosFromGallery?.length > 0
            ? stateVars.PhotosFromGallery[0].dataBase64
            : null
          : this.state.PhotosFromGallery?.length > 0
          ? this.state.PhotosFromGallery[0].dataBase64
          : null
      ),
      null,
      null
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  RequestImagesMobilComponent_435247_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find((v) => !v.isValid && v.condition);
      if (invalidValidation) {
        const fieldIdMatch = invalidValidation.formName.match(/\d+/);
        if (fieldIdMatch) {
          const fieldId = fieldIdMatch[0];
          const fieldElement = document.getElementById(fieldId);
          if (fieldElement) {
            fieldElement.scrollIntoView({ behavior: "smooth", block: "center" });
          }
        }
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.PhotosFromGallery = (
      (await ReactSystemFunctions.getPhotosFromGallery(
        false,
        ReactSystemFunctions.convertToTypeByName("high", "string")
      )) as any
    ).data;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.RequestImagesMobilComponent_435247_onClick1_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  RequestImagesMobilComponent_435247_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find((v) => !v.isValid && v.condition);
      if (invalidValidation) {
        const fieldIdMatch = invalidValidation.formName.match(/\d+/);
        if (fieldIdMatch) {
          const fieldId = fieldIdMatch[0];
          const fieldElement = document.getElementById(fieldId);
          if (fieldElement) {
            fieldElement.scrollIntoView({ behavior: "smooth", block: "center" });
          }
        }
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      FrontView_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.PhotosFromGallery !== undefined
            ? stateVars.PhotosFromGallery?.length > 0
              ? stateVars.PhotosFromGallery[0].dataBase64
              : null
            : this.state.PhotosFromGallery?.length > 0
            ? this.state.PhotosFromGallery[0].dataBase64
            : null
        ),
        "string"
      ),
      RequestFormID_0_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.ReguestFormID ?? this.props.screenInputs.reguestformid,
        "Guid"
      )
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "RequestImagesMobil/RequestImagesMobilComponent_435247_onClick1_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.SaveRecord_1 = result?.data.saveRecord_1;
    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };

  RequestImagesMobilComponent_582336_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find((v) => !v.isValid && v.condition);
      if (invalidValidation) {
        const fieldIdMatch = invalidValidation.formName.match(/\d+/);
        if (fieldIdMatch) {
          const fieldId = fieldIdMatch[0];
          const fieldElement = document.getElementById(fieldId);
          if (fieldElement) {
            fieldElement.scrollIntoView({ behavior: "smooth", block: "center" });
          }
        }
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.DownloadFile = await ReactSystemFunctions.downloadFile(
      ReactSystemFunctions.toString(
        this,
        stateVars.RequestImageGet !== undefined
          ? stateVars.RequestImageGet?.length > 0
            ? stateVars.RequestImageGet[0].frontView
            : null
          : this.state.RequestImageGet?.length > 0
          ? this.state.RequestImageGet[0].frontView
          : null
      ),
      ReactSystemFunctions.convertToTypeByName("Önden Çekim", "string")
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  RequestImagesMobilComponent_969827_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find((v) => !v.isValid && v.condition);
      if (invalidValidation) {
        const fieldIdMatch = invalidValidation.formName.match(/\d+/);
        if (fieldIdMatch) {
          const fieldId = fieldIdMatch[0];
          const fieldElement = document.getElementById(fieldId);
          if (fieldElement) {
            fieldElement.scrollIntoView({ behavior: "smooth", block: "center" });
          }
        }
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "DetailImage",
      "PView",
      ReactSystemFunctions.convertToTypeByName("FrontView", "string")
    );
    KuikaAppManager.addToPageInputVariables(
      "DetailImage",
      "ReguestFormID",
      ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.ReguestFormID ?? this.props.screenInputs.reguestformid,
        "Guid"
      )
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "RequestImagesMobil",
      "DetailImage",
      "",
      "newTab",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  RequestImagesMobilComponent_431067_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find((v) => !v.isValid && v.condition);
      if (invalidValidation) {
        const fieldIdMatch = invalidValidation.formName.match(/\d+/);
        if (fieldIdMatch) {
          const fieldId = fieldIdMatch[0];
          const fieldElement = document.getElementById(fieldId);
          if (fieldElement) {
            fieldElement.scrollIntoView({ behavior: "smooth", block: "center" });
          }
        }
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      FrontView_0: ReactSystemFunctions.convertToTypeByName(null, "string"),
      RequestFormID_0_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.ReguestFormID ?? this.props.screenInputs.reguestformid,
        "Guid"
      )
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "RequestImagesMobil/RequestImagesMobilComponent_431067_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.SaveRecord_2 = result?.data.saveRecord_2;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.RequestImagesMobilComponent_431067_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  RequestImagesMobilComponent_431067_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find((v) => !v.isValid && v.condition);
      if (invalidValidation) {
        const fieldIdMatch = invalidValidation.formName.match(/\d+/);
        if (fieldIdMatch) {
          const fieldId = fieldIdMatch[0];
          const fieldElement = document.getElementById(fieldId);
          if (fieldElement) {
            fieldElement.scrollIntoView({ behavior: "smooth", block: "center" });
          }
        }
      }
      return true;
    }

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName("requestimagesmobil_155149_value", "string"),
      "",
      null,
      null
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  RequestImagesMobilComponent_497406_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find((v) => !v.isValid && v.condition);
      if (invalidValidation) {
        const fieldIdMatch = invalidValidation.formName.match(/\d+/);
        if (fieldIdMatch) {
          const fieldId = fieldIdMatch[0];
          const fieldElement = document.getElementById(fieldId);
          if (fieldElement) {
            fieldElement.scrollIntoView({ behavior: "smooth", block: "center" });
          }
        }
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.PhotosFromGallery = (
      (await ReactSystemFunctions.getPhotosFromGallery(
        false,
        ReactSystemFunctions.convertToTypeByName("high", "string")
      )) as any
    ).data;
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName("requestimagesmobil_215414_value", "string"),
      ReactSystemFunctions.value(
        this,
        stateVars.PhotosFromGallery !== undefined
          ? stateVars.PhotosFromGallery?.length > 0
            ? stateVars.PhotosFromGallery[0].dataBase64
            : null
          : this.state.PhotosFromGallery?.length > 0
          ? this.state.PhotosFromGallery[0].dataBase64
          : null
      ),
      null,
      null
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  RequestImagesMobilComponent_656449_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find((v) => !v.isValid && v.condition);
      if (invalidValidation) {
        const fieldIdMatch = invalidValidation.formName.match(/\d+/);
        if (fieldIdMatch) {
          const fieldId = fieldIdMatch[0];
          const fieldElement = document.getElementById(fieldId);
          if (fieldElement) {
            fieldElement.scrollIntoView({ behavior: "smooth", block: "center" });
          }
        }
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.DownloadFile = await ReactSystemFunctions.downloadFile(
      ReactSystemFunctions.toString(
        this,
        stateVars.RequestImageGet !== undefined
          ? stateVars.RequestImageGet?.length > 0
            ? stateVars.RequestImageGet[0].sideView
            : null
          : this.state.RequestImageGet?.length > 0
          ? this.state.RequestImageGet[0].sideView
          : null
      ),
      ReactSystemFunctions.convertToTypeByName("Yandan Çekim", "string")
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  RequestImagesMobilComponent_589927_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find((v) => !v.isValid && v.condition);
      if (invalidValidation) {
        const fieldIdMatch = invalidValidation.formName.match(/\d+/);
        if (fieldIdMatch) {
          const fieldId = fieldIdMatch[0];
          const fieldElement = document.getElementById(fieldId);
          if (fieldElement) {
            fieldElement.scrollIntoView({ behavior: "smooth", block: "center" });
          }
        }
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "DetailImage",
      "PView",
      ReactSystemFunctions.convertToTypeByName("SideView", "string")
    );
    KuikaAppManager.addToPageInputVariables(
      "DetailImage",
      "ReguestFormID",
      ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.ReguestFormID ?? this.props.screenInputs.reguestformid,
        "Guid"
      )
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "RequestImagesMobil",
      "DetailImage",
      "",
      "newTab",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  RequestImagesMobilComponent_283058_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find((v) => !v.isValid && v.condition);
      if (invalidValidation) {
        const fieldIdMatch = invalidValidation.formName.match(/\d+/);
        if (fieldIdMatch) {
          const fieldId = fieldIdMatch[0];
          const fieldElement = document.getElementById(fieldId);
          if (fieldElement) {
            fieldElement.scrollIntoView({ behavior: "smooth", block: "center" });
          }
        }
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      SideView_0: ReactSystemFunctions.convertToTypeByName(null, "string"),
      RequestFormID_0_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.ReguestFormID ?? this.props.screenInputs.reguestformid,
        "Guid"
      )
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "RequestImagesMobil/RequestImagesMobilComponent_283058_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.SaveRecord_3 = result?.data.saveRecord_3;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.RequestImagesMobilComponent_283058_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  RequestImagesMobilComponent_283058_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find((v) => !v.isValid && v.condition);
      if (invalidValidation) {
        const fieldIdMatch = invalidValidation.formName.match(/\d+/);
        if (fieldIdMatch) {
          const fieldId = fieldIdMatch[0];
          const fieldElement = document.getElementById(fieldId);
          if (fieldElement) {
            fieldElement.scrollIntoView({ behavior: "smooth", block: "center" });
          }
        }
      }
      return true;
    }

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName("requestimagesmobil_215414_value", "string"),
      "",
      null,
      null
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  RequestImagesMobilComponent_826741_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find((v) => !v.isValid && v.condition);
      if (invalidValidation) {
        const fieldIdMatch = invalidValidation.formName.match(/\d+/);
        if (fieldIdMatch) {
          const fieldId = fieldIdMatch[0];
          const fieldElement = document.getElementById(fieldId);
          if (fieldElement) {
            fieldElement.scrollIntoView({ behavior: "smooth", block: "center" });
          }
        }
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.PhotosFromGallery = (
      (await ReactSystemFunctions.getPhotosFromGallery(
        false,
        ReactSystemFunctions.convertToTypeByName("high", "string")
      )) as any
    ).data;
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName("requestimagesmobil_554399_value", "string"),
      ReactSystemFunctions.value(
        this,
        stateVars.PhotosFromGallery !== undefined
          ? stateVars.PhotosFromGallery?.length > 0
            ? stateVars.PhotosFromGallery[0].dataBase64
            : null
          : this.state.PhotosFromGallery?.length > 0
          ? this.state.PhotosFromGallery[0].dataBase64
          : null
      ),
      null,
      null
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  RequestImagesMobilComponent_733066_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find((v) => !v.isValid && v.condition);
      if (invalidValidation) {
        const fieldIdMatch = invalidValidation.formName.match(/\d+/);
        if (fieldIdMatch) {
          const fieldId = fieldIdMatch[0];
          const fieldElement = document.getElementById(fieldId);
          if (fieldElement) {
            fieldElement.scrollIntoView({ behavior: "smooth", block: "center" });
          }
        }
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.DownloadFile = await ReactSystemFunctions.downloadFile(
      ReactSystemFunctions.toString(
        this,
        stateVars.RequestImageGet !== undefined
          ? stateVars.RequestImageGet?.length > 0
            ? stateVars.RequestImageGet[0].closeUpView
            : null
          : this.state.RequestImageGet?.length > 0
          ? this.state.RequestImageGet[0].closeUpView
          : null
      ),
      ReactSystemFunctions.convertToTypeByName("Yakından Çekim", "string")
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  RequestImagesMobilComponent_633549_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find((v) => !v.isValid && v.condition);
      if (invalidValidation) {
        const fieldIdMatch = invalidValidation.formName.match(/\d+/);
        if (fieldIdMatch) {
          const fieldId = fieldIdMatch[0];
          const fieldElement = document.getElementById(fieldId);
          if (fieldElement) {
            fieldElement.scrollIntoView({ behavior: "smooth", block: "center" });
          }
        }
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "DetailImage",
      "PView",
      ReactSystemFunctions.convertToTypeByName("CloseUpView", "string")
    );
    KuikaAppManager.addToPageInputVariables(
      "DetailImage",
      "ReguestFormID",
      ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.ReguestFormID ?? this.props.screenInputs.reguestformid,
        "Guid"
      )
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "RequestImagesMobil",
      "DetailImage",
      "",
      "newTab",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  RequestImagesMobilComponent_256181_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find((v) => !v.isValid && v.condition);
      if (invalidValidation) {
        const fieldIdMatch = invalidValidation.formName.match(/\d+/);
        if (fieldIdMatch) {
          const fieldId = fieldIdMatch[0];
          const fieldElement = document.getElementById(fieldId);
          if (fieldElement) {
            fieldElement.scrollIntoView({ behavior: "smooth", block: "center" });
          }
        }
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      CloseUpView_0: ReactSystemFunctions.convertToTypeByName(null, "string"),
      RequestFormID_0_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.ReguestFormID ?? this.props.screenInputs.reguestformid,
        "Guid"
      )
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "RequestImagesMobil/RequestImagesMobilComponent_256181_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.SaveRecord_4 = result?.data.saveRecord_4;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.RequestImagesMobilComponent_256181_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  RequestImagesMobilComponent_256181_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find((v) => !v.isValid && v.condition);
      if (invalidValidation) {
        const fieldIdMatch = invalidValidation.formName.match(/\d+/);
        if (fieldIdMatch) {
          const fieldId = fieldIdMatch[0];
          const fieldElement = document.getElementById(fieldId);
          if (fieldElement) {
            fieldElement.scrollIntoView({ behavior: "smooth", block: "center" });
          }
        }
      }
      return true;
    }

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName("requestimagesmobil_554399_value", "string"),
      "",
      null,
      null
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  RequestImagesMobilComponent_755768_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    validations.push({
      isValid: ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(this, "requestimagesmobil_554399_value", "value", "", "", ""),
        null
      ),
      message: "Resim 3 Ekleyiniz",
      formName: "requestimagesmobil_554399_value",
      condition: true
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });
    validations.push({
      isValid: ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(this, "requestimagesmobil_155149_value", "value", "", "", ""),
        null
      ),
      message: "Resim 1 Ekleyiniz",
      formName: "requestimagesmobil_155149_value",
      condition: true
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });
    validations.push({
      isValid: ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(this, "requestimagesmobil_215414_value", "value", "", "", ""),
        null
      ),
      message: "Resim 2 Ekleyiniz",
      formName: "requestimagesmobil_215414_value",
      condition: true
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find((v) => !v.isValid && v.condition);
      if (invalidValidation) {
        const fieldIdMatch = invalidValidation.formName.match(/\d+/);
        if (fieldIdMatch) {
          const fieldId = fieldIdMatch[0];
          const fieldElement = document.getElementById(fieldId);
          if (fieldElement) {
            fieldElement.scrollIntoView({ behavior: "smooth", block: "center" });
          }
        }
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      CloseUpView_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(this, "requestimagesmobil_554399_value", "value", "", "", "")
        ),
        "string"
      ),
      FrontView_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(this, "requestimagesmobil_155149_value", "value", "", "", "")
        ),
        "string"
      ),
      SideView_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(this, "requestimagesmobil_215414_value", "value", "", "", "")
        ),
        "string"
      ),
      RequestFormID_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.ReguestFormID ?? this.props.screenInputs.reguestformid,
        "Guid"
      ),
      Id_0: ReactSystemFunctions.convertToTypeByName(Guid.create().toString(), "Guid")
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "RequestImagesMobil/RequestImagesMobilComponent_755768_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.RequestImageSave = result?.data.requestImageSave;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.RequestImagesMobilComponent_755768_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  RequestImagesMobilComponent_755768_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find((v) => !v.isValid && v.condition);
      if (invalidValidation) {
        const fieldIdMatch = invalidValidation.formName.match(/\d+/);
        if (fieldIdMatch) {
          const fieldId = fieldIdMatch[0];
          const fieldElement = document.getElementById(fieldId);
          if (fieldElement) {
            fieldElement.scrollIntoView({ behavior: "smooth", block: "center" });
          }
        }
      }
      return true;
    }

    await this.RequestImagesMobilPageInit();

    stateVars.GoBack = await ReactSystemFunctions.goBack(this);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
  }

  getWfPageComponent = () => {
    return ReactSystemFunctions.getWfPageComponent(this, this.state.wfScreenName);
  };
}
